import { useEffect, useRef } from 'react';
import axios from 'axios';

const useAxiosCancel = () => {
    const cancelTokens = useRef([]);

    useEffect(() => {
        return () => {
            // Cancel all requests on component unmount
            cancelTokens?.current?.forEach((source) => source.cancel('Operation canceled by the user.'));
        };
    }, []);

    const getCancelToken = () => {
        const source = axios.CancelToken.source();
        cancelTokens.current.push(source);
        return source.token;
    };

    return getCancelToken;
};

export default useAxiosCancel;